import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-hot-toast';

const AdminInvite = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [validToken, setValidToken] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        // Token'ın geçerliliğini kontrol et
        const validateToken = async () => {
            try {
                console.log('Validating token:', token);
                // API isteğini düzgün şekilde yapılandırın
                const response = await api.get(`/admin/validate-invite/${token}`);
                console.log('Validation response:', response.data);
                setValidToken(response.data.valid);
            } catch (error) {
                console.error('Error validating token:', error);
                toast.error('Invalid or expired invitation link');
                setValidToken(false);
            } finally {
                setLoading(false);
            }
        };

        validateToken();
    }, [token]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Şifre kontrolü
        if (formData.password !== formData.confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        try {
            setLoading(true);
            await api.post('/admin/accept-invite', {
                token,
                name: formData.name,
                email: formData.email,
                password: formData.password
            });
            
            toast.success('Admin account created successfully');
            navigate('/login');
        } catch (error) {
            console.error('Error accepting invite:', error);
            toast.error(error.response?.data?.message || 'Failed to create admin account');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#0A192F]">
                <div className="text-[#64FFDA] text-xl">Loading...</div>
            </div>
        );
    }

    if (!validToken) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-[#0A192F] p-4">
                <div className="bg-[#112240] rounded-xl p-8 max-w-md w-full">
                    <h1 className="text-2xl font-bold text-[#64FFDA] mb-4">Invalid Invitation</h1>
                    <p className="text-gray-300 mb-6">
                        This invitation link is invalid or has expired.
                    </p>
                    <button
                        onClick={() => navigate('/login')}
                        className="w-full py-2 bg-[#64FFDA] text-[#0A192F] rounded-lg font-medium hover:bg-[#64FFDA]/90 transition-colors"
                    >
                        Go to Login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
            <div className="bg-[#151515] rounded-xl p-8 max-w-md w-full border border-[#FF3366]/20">
                <h1 className="text-2xl font-bold text-white mb-4">Create Admin Account</h1>
                <p className="text-gray-400 mb-6">
                    Complete the form below to create your admin account.
                </p>
                
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-gray-300 mb-2">Full Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full p-2 bg-[#0A0A0A] border border-[#FF3366]/20 rounded text-white"
                        />
                    </div>
                    
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-gray-300 mb-2">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full p-2 bg-[#0A0A0A] border border-[#FF3366]/20 rounded text-white"
                        />
                    </div>
                    
                    <div className="mb-4">
                        <label htmlFor="password" className="block text-gray-300 mb-2">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="w-full p-2 bg-[#0A0A0A] border border-[#FF3366]/20 rounded text-white"
                        />
                    </div>
                    
                    <div className="mb-6">
                        <label htmlFor="confirmPassword" className="block text-gray-300 mb-2">Confirm Password</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            className="w-full p-2 bg-[#0A0A0A] border border-[#FF3366]/20 rounded text-white"
                        />
                    </div>
                    
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-2 bg-gradient-to-r from-[#FF3366] to-[#FF6B4D] text-white rounded-lg font-medium hover:from-[#FF3366]/90 hover:to-[#FF6B4D]/90 transition-colors disabled:opacity-50"
                    >
                        {loading ? 'Creating Account...' : 'Create Account'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminInvite; 